module.exports = __webpack_public_path__ + "static/media/6.8f598ac3.jpg";